import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./ProductDetails.css";
import NavBar2 from "../../Shared/NavBar2/NavBar2";
import { Col, Row } from "react-bootstrap";
import Footer from "../../Shared/Footer/Footer";
const ProductDetails = () => {
  let { id } = useParams();
  const [productDetail, setProductDetail] = useState({});
  const [counter, setCounter] = useState(0);
  useEffect(() => {
    fetch(`https://carame-cake-server-site.vercel.app/homeProducts/${id}`)
      .then((res) => res.json())
      .then((data) => setProductDetail(data));
  }, [id]);
  //increase counter
  const increase = () => {
    setCounter(count => count + 1);
  };
  //decrease counter
  const decrease = () => {
    if (counter > 0) {
      setCounter(count => count - 1);
    }
  };
  return (
    <div>
      <NavBar2 />
      <div className="container-fluid row mt-5 pt-5">
        <div className="col-lg-4 col-sm-12 ">
          <img
            className="mb-4 centering img-fluid"
            src={productDetail.img}
            style={{ width: "400px", height: "550px" }}
            alt=""
          />
        </div>
        <div className="col-lg-5 col-sm-12  mb-5 ">
          <h6>{productDetail.title}</h6>
          <span style={{ color: "#E47277", fontWeight: "bold" }}>
            ${productDetail.price}.00 USD
          </span>
          <br />
          <span>No reviews</span>
          <hr />
          {productDetail.details ? (
            <p className="details">{productDetail.details}</p>
          ) : (
            <p className="details">
              Calf-length dress in airy, textured cotton fabric with a printed
              pattern Sed hendrerit. Cras risus ipsum, faucibus ut, ullamcorper
              id, varius estibulum ante ipsum primis in faucibus Product Details
              Inspired by traditional blockprinting techniques in India, our own
              in-house design is the vibrant pattern that every closet needs.
              That's why...
            </p>
          )}
          <div className="d-flex full-width">
            <div>
              <div className="d-flex">
                <input
                  style={{ width: "50px", textAlign: "center" }}
                  type="text"
                  className="js-qty__num"
                  value={counter}
                  min="1"
                  data-id=""
                  aria-label="quantity"
                  pattern="[0-9]*"
                  name="quantity"
                  id="Quantity"
                />
                <div>
                  <button
                    type="button"
                    className="btn6"
                    data-id=""
                    data-qty="11"
                    onClick={increase}
                  >
                    <span className="fa fa-plus"></span>
                  </button>
                  <br />
                  <button
                    type="button"
                    className="btn6"
                    data-id=""
                    data-qty="0"
                    onClick={decrease}
                  >
                    <span className="fa fa-minus"></span>
                  </button>
                </div>
              </div>
            </div>
            <button
              type="submit"
              className="ms-3  addToCart"
              value="Add to Cart"
              style={{ opacity: 1 }}
            >
              ADD TO CART
            </button>
          </div>
          <Link to={`/order/${productDetail._id}`}>
            {" "}
            <button className="btn3 mt-5">BUY IT NOW</button>
          </Link>
          <br />
          {productDetail.categories ? (
            <small>Categories: {productDetail.categories}</small>
          ) : (
            <small>Shop Products</small>
          )}
        </div>
        {/* col-3 */}
        <div className="col-lg-3 col-sm-12 col-xs-12">
          <div className="card border1 p-2">
            <div className="card-body text-center">
              <h5 className="card-title">Why Choose Us ?</h5>
              <p className="card-text details1">
                Official Herschel stockist Australian warranty assistance &
                support Australian shipping & returns.Customer first experience
                environmentally focused
              </p>
            </div>
          </div>
          <div className="card border1 p-2 mt-4">
            <div className="card-body text-center">
              <h5 className="card-title">Returns</h5>
              <p className="card-text details1">
                Return this product within 100 days if you change your mind. Get
                a refund/replacement & free return shipping if it arrives
                damaged or not as described
              </p>
            </div>
          </div>
          <div className="card border1 p-2 mt-4 mb-3">
            <div className="card-body text-center">
              <h5 className="card-title">Shipping</h5>
              <p className="card-text details1">
                Free if stated near price. $9.95 Australia wide (up to 10
                items). $18.95 for Express Post (generally 1 business day).
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* second section */}
      <div className="container-fluid mb-5 pb-5 ">
        <Row lg={2}>
          <Col sm={12}>
            <img
              style={{ width: "500px" }}
              className="img1 img-fluid"
              src="https://i.ibb.co/XjwLMtJ/description1.jpg"
              alt=""
            />
          </Col>
          <Col sm={12}>
            {/*
             */}
            <h3 className="mt-5 pt-5">
              Calf-Length Dress In Airy, Textured Cotton Fabric With A Printed
              Pattern
            </h3>
            <span className="details1">
              Sed hendrerit. Cras risus ipsum, faucibus ut, ullamcorper id,
              varius estibulum ante ipsum primis in faucibus
            </span>{" "}
            <br />
            <img
              style={{ width: "600px", height: "450px" }}
              className="mt-5 img2 img-fluid"
              src="https://i.ibb.co/wYM6DNz/description2.jpg"
              alt=""
            />
          </Col>
        </Row>
      </div>
      {/* details */}
      <div className="text-center">
        <p className="details" style={{ fontWeight: "bold" }}>
          PRODUCT DETAILS
        </p>
        <span className="details1">
          Inspired by traditional blockprinting techniques in India, our own
          in-house design is the vibrant pattern that every closet needs. That's
          why we crafted our party standout tiered maxi dress in this royal
          blue-and-yellow print: It's lightweight, lined and will look great at
          all your most festive summer events.
        </span>{" "}
        <br />
        <img
          src="https://i.ibb.co/fqDrrQr/description3.jpg"
          className="img-fluid mt-4 mb-4"
          alt=""
        />
        <hr />
      </div>
      <Footer />
    </div>
  );
};

export default ProductDetails;
